// extracted by mini-css-extract-plugin
export var errorIcon = "_kf-1";
export var nameLogo = "_kf-0";